import { render, staticRenderFns } from "./SpoiledHint.vue?vue&type=template&id=0f3d37e2&scoped=true&"
import script from "./SpoiledHint.vue?vue&type=script&lang=js&"
export * from "./SpoiledHint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f3d37e2",
  null
  
)

export default component.exports